module.exports = __webpack_public_path__ + "img/1.88639b7c.jpg";